<template>
  <div v-if="latestNews.length" class="subscription-bar__latest-news">
    <!-- Title -->
    <h2 class="subscription-bar__latest-news__title">
      {{ $i18n('blog.latest-news') }}
    </h2>
    <!-- ./Title -->

    <!-- Latest News -->
    <article
      v-for="(post, index) in latestNews"
      :key="`latest-news-${index}`"
      :class="['article', { 'mb-[30px]': index !== latestNews.length - 1 }]"
    >
      <!-- Article Thumbnail -->
      <picture class="article__featured-image">
        <img v-if="post.thumbnail" :src="post.thumbnail" :alt="post.title" loading="lazy" width="100%" height="100%" />
      </picture>
      <!-- ./Article Thumbnail -->

      <!-- Single Article -->
      <div class="flex flex-col gap-[22px] px-[19px]">
        <!-- Title -->
        <a :href="`/blog/${post.slug}/`" :aria-label="post.title">
          <h3 class="article__title" :title="post.title" v-html="post.title" />
        </a>
        <!-- ./Title -->

        <!-- Post Info -->
        <DateAndMinRead :post-date="post.date" :min-read="post.minRead" />
        <!-- ./Post Info -->
      </div>
      <!-- ./Single Article -->
    </article>
    <!-- ./Latest News -->
  </div>
</template>
<script>
import DateAndMinRead from '~/components/blog/DateAndMinRead.vue';

export default {
  name: 'LatestNews',
  components: {
    DateAndMinRead,
  },
  computed: {
    latestNews() {
      return this.$store.state.post.list.posts.slice(0, 2);
    },
  },
};
</script>
<style lang="scss" scoped>
.subscription-bar {
  &__latest-news {
    @apply md:w-3/5 gap-[19px];

    &__title {
      @apply font-cocogoose text-[18px] mb-[30px];
    }
  }

  .article {
    @apply relative flex flex-row md:items-center hover:bg-gray-200 hover:text-orange-500 duration-300 rounded-[4px];

    &:hover {
      .article__featured-image {
        & img {
          @apply scale-110;
        }

        &::after {
          @apply -top-[100%];
        }
      }
    }

    &__title {
      @apply font-cocogoose text-[16px] md:leading-[1.67];

      &::after {
        content: '';
        @apply block absolute z-10 inset-0 pointer-events-auto cursor-pointer w-full h-full;
      }
    }

    &__featured-image {
      @apply relative flex-shrink-0 w-[120px] h-[120px] overflow-hidden rounded-[4px];

      & > img {
        @apply duration-500 w-full h-full object-cover;
      }

      &::after {
        content: '';
        @apply inset-0 bg-gray-300 opacity-10 absolute w-full h-full duration-500;
      }
    }
  }
}
</style>
